<template>
  <div>
    <div class="labar">
      <span
        v-for="(item,i) of tabbar"
        :key="i"
        @click="laberRoute(i)"
      >{{item}}
        <span v-if="i<tabbar.length-1"> > </span>
      </span>
    </div>
  </div>
</template>
<script>
import {languageList} from "../utils/languageTar";
export default {
  data() {
    return {
      tabbar: [],
      laPath: []
    };
  },
  methods: {
    laberRoute(i) {
      // console.log(item)
      var tabs = JSON.parse(this.$route.query.laber);
      var laber = tabs.slice(0, i + 1);
      var laPath = this.laPath.slice(0, i + 1);
      // console.log(laber,laPath)
      if (this.laPath[i] != this.$route.path) {
        this.$router.push({
          path: this.laPath[i],
          query: {
            laber: JSON.stringify(laber),
            laPath: JSON.stringify(laPath)
          }
        });
      }
    }
  },
  created() {
    var tabs = JSON.parse(this.$route.query.laber);
    this.laPath = JSON.parse(this.$route.query.laPath);
    this.laPath.push(this.$route.path);
    this.tabbar=[]
    
    for (var i of tabs) {
      // console.log(i)
      this.tabbar.push(languageList()[i]);
    }
    // console.log(tabs,this.tabbar,'sfusjfgs将发动机盖')
  },
  watch: {
    $route(to,from) {
      var tabs = JSON.parse(this.$route.query.laber);
      this.laPath = JSON.parse(this.$route.query.laPath);
      this.laPath.push(this.$route.path);
      this.tabbar=[]
      for (var i of tabs) {
        this.tabbar.push(languageList()[i]);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/layout/LabarsBread.vue